import { render, staticRenderFns } from "./queries-table.component.vue?vue&type=template&id=7196243e"
import script from "./queries-table.component.vue?vue&type=script&lang=ts"
export * from "./queries-table.component.vue?vue&type=script&lang=ts"
import style0 from "./queries-table.component.vue?vue&type=style&index=0&id=7196243e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports